import { render, staticRenderFns } from "./CarrierPP.vue?vue&type=template&id=4d87fe7f&"
import script from "./CarrierPP.vue?vue&type=script&lang=js&"
export * from "./CarrierPP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports